/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    Category,
    Flag,
    FlagOutlined,
    Inventory2Outlined,
    PointOfSaleOutlined,
    TurnedInNotOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOPRODUCTOS} from "../../Constantes";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoImagenCropLista from "../../Modulo_formularios/Componentes/IngresoImagenCropLista";

const Formulario_Producto_Fotos = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Inventory2Outlined} nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props} editable={false}
                    />
                </Grid2>

                <Grid2 container size={12}>
                    <IngresoImagenCropLista Icono={TurnedInNotOutlined} nombre={'Marca del producto'}
                                  dato={'imgs'} {...props}

                    />
                </Grid2>




            </Grid2>

        </form>

    )

}
export default Formulario_Producto_Fotos